import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
// import WhyStudyAbroad from './WhyStudyAbroad'
// import Browse from './Browse'
// import Whatsnew2 from './whatsnew2'
// import StartTestimonials from './testimonials'
// import Aboutsection from './aboutsection'
// import IndividualUniversity from './IndividualUniversity'
import CountUp from 'react-countup'
// import Destination from './Destination'
import SearchFilterSort from './SearchFilterSort'
import UniversityRankingList from './UniversityRankingList'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetTopRankingsUniversitiesWithFiltersApiQuery } from '../../../core/Features/api/findACourse/universityRankings/universityRankings';
import Pagination from '../../StudyDestination/Australia/Pagination';
import Unlock from '../../HomePages/home-palani/section/Unlock';

// import Benefits from './Benefits'
// import About from './about-us'

const UniversityRankings = () => {
    const [akash, setAkash] = useState()
    const [SelectedId, setSelectedId] = useState()
    const [page, setPage] = useState(1);
    const limit = 10; // item per page

    console.log("test akash for the web", akash)
    const queryParams = [
        // `studyLevelIds=${reduxValue?.levels?.join(",")}`,
        // `destinationIds=${reduxValue?.countries?.join(",")}`,
        `search=${akash}`,
        `parentIds=${SelectedId}`,
        `page=${page}`,
        `limit=${limit}`
    ].join("&");

    const { data, isLoading, isError } = useGetTopRankingsUniversitiesWithFiltersApiQuery(queryParams);

    const apiValues = data?.data || {};
    const apiValues2 = data?.pageDetails || {};
    const totalPages = data?.totalPages
    const destinations = data?.destinations || [];


    const bgImageUrl = "/assets/img/backgroundpalanicard/cardbackground.jpg"; // Replace with actual image URL


    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);


    return (
        <>
            <>

                {/* banner */}

                <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0 bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues2?.bannerImageUrl})`,
                                                        backgroundSize:"100% 100%",

                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues2?.bannerTitle}
                                            </h6>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <div className='p-3'>

                    <div className='z-50 relative'>
                        <SearchFilterSort setAkash={setAkash} destinations={destinations} setSelectedId={setSelectedId} />
                    </div>


                    <div className="flex flex-col lg:flex-row gap-4 w-full mt-3 p-2">
                        {/* Left Side: Tall content */}
                        <div className="w-full lg:w-[75%]">
                            <UniversityRankingList apiValues={apiValues} totalItems={data?.totalItems} />
                        </div>

                        {/* Right Side: Compact Image Card */}
                        <div
                            className="w-full lg:w-[25%] flex flex-col rounded-md border border-gray-300 p-4 space-y-4 bg-cover bg-center min-h-[200px]"
                            style={{ backgroundImage: `url(${bgImageUrl})` }}
                        >
                            <ImageWithBasePath
                                src="assets/img/individual/image2.png"
                                alt="img"
                                className="w-full h-auto max-w-[220px] mx-auto"
                            />

                            <div className="flex justify-center">
                                <ImageWithBasePath
                                    src="assets/img/individual/logo.png"
                                    alt="img"
                                    className="w-40 h-auto sm:w-32 md:w-36"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col justify-center items-center p-4">
                        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
                    </div>

                    <Unlock />

                </div>





            </>

        </>
    )
}

export default UniversityRankings




